import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import "./login.scss";

const Login = ({setAuth}) => {
  const [inputs, setInputs] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleChange = (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
  
    const was_auth = await login(inputs.username, inputs.password);
    setAuth(was_auth);
    if (was_auth === true){
      console.log("Redirecting to homepage");
      navigate('/'); 
    }else{
      console.log("display error message");
      setError('Invalid credentials. Please try again.');
    }
    
  };

  return (
    <div className="login">
      <div className="card">
        <div className="left">
          <h1>Authorized Access Only</h1>
          <p>
          By logging in, you agree to comply with all applicable laws and organizational policies. Unauthorized access is prohibited and may result in legal action.
          </p>
          {/* <span>Don't you have an account?</span>
          <Link to="/register">
            <button>Register</button>
          </Link> */}
        </div>
        <div className="right">
          <h1>Login</h1>
          {error && <p className="error">{error}</p>}
          <form onSubmit={handleSubmit} >
            <input type="text" placeholder="Username" 
            name="username"
          autoComplete="current-username"
          onChange={handleChange}
          required/>
            <input type="password" placeholder="Password"
            name="password"
          onChange={handleChange}
          autoComplete="current-password"
          required />
            <button type="submit">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
